<template>
  <div class="normal-price-page">

    <el-breadcrumb style="margin-top: 15px;" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Campaign/' + this.$route.params.Id }" class="first-breadcrumb">{{ $t('promomgmt.t1') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('promomgmt.t17') }}</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="promotion-detail-list">
      <el-table 
        :data="exceldatatable"
        :cell-style="getTableCellStyle"
        size="mini" 
        tooltip-effect="dark" 
        style="width: 100%;"
        @cell-dblclick="editSinglePrcie">
        <el-table-column label="SKUID" prop="skuid" width="100" fixed></el-table-column>
        <el-table-column :label="$t('jgjk.s13')" prop="series" width="100"></el-table-column>
        <el-table-column :label="$t('report.s18')" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('jgjk.s14')" prop="model" width="100"></el-table-column>
        <el-table-column :label="$t('jgjk.s16')" prop="type" width="100"></el-table-column>
        <el-table-column label="SKUCODE" prop="sku" width="120"></el-table-column>
        <el-table-column :label="$t('jgjk.s305')" prop="price" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.isedittype ===  false">{{scope.row.price}}</span>
            <el-input 
              v-inputfocus
              onkeyup="value=value.replace(/[^0-9.]/g,'')" 
              class="editpriceinput" 
              v-model="scope.row.price" 
              v-if="scope.row.isedittype === true" 
              @blur="savePrice(scope.row.skuid, scope.row.price, scope.row)"
              @keyup.enter.native="savePrice(scope.row.skuid, scope.row.price, scope.row)"
              size="mini">
            </el-input>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagewrap">
        <el-pagination
          small
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          popper-class="pagesizeclass"
          :page-sizes="[25, 50, 100]"
          :page-size="size"
          layout="total, prev, pager, next, sizes"
          :total="pagingtotal">
        </el-pagination>      
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      exceldatatable: [],
      subid: this.$route.params.Id,
      page: 1,
      size: 25,
      pagingtotal: 0
    }
  },

  mounted(){
    this.getPriceList()
  },

  methods: {


    /**
     * 获取价格详情列表
     */
    getPriceList: function(){
      let that = this
      let url = that.API_URL + '/v3/price/monitor/paging'
      let gets = {
        subid: that.subid,
        page: 1,
        size: 25,
        start: '',
        end: '',
        channel: '',
        series: '',
        model: '',
        search: '',
        order: ''
      }
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
				data: gets,
        success: function(data){
          console.log('--', data)
          let _data = data.results[1]
          
          _data.forEach(item => {
            item.updateAt = item.updateAt ? that.$moment(item.updateAt).format('MM-DD HH:mm') : ''
            item.trend = ''
            item.Discount = (item.Discount * 100).toFixed(2) + "%"
            item.skuidIcon = item.HasNew/1 === 1 ? item.skuid + ' <i class="icon-newdata-txt">New</i>' : item.skuid
            item.price = item.price * 1,
            item.isedittype = false
          })

          that.exceldatatable = _data
          that.pagingtotal = data.results[0][0].Count
        },
        error: function(err){
          console.log(err)
        }
      })
    },

    /**
     * 修改每页显示条数
     */
    handleSizeChange: function(val){
      this.size = val
      this.page = 1
      this.getPriceList()
    },

    /**
     * 翻页
     */
    handleCurrentChange: function(val){
      this.page = val
      this.getPriceList()
    },

    /**
     * 修改行内价格
     */
    editSinglePrcie: function(row, column){
      console.log(column)
      if(column.property == 'price'){
        row.isedittype = true
      }
    },
    
    /**
     * 保存行内价格修改
     */
    savePrice: function(id, price, row){
      let that = this
      if(price===''){
        return 
      }
      row.isedittype = false
      let url = that.API_URL + '/v3/price/monitor/updatesku'
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {skuid: id, price: price},
        success: function(data) {
          console.log('savePrice', data)
          row.isedittype = false
        },
        error: function(response) {
          console.log('savePrice', response)
        }
      })
    },

  }
}
</script>